import script from "./LoanPurpose.vue?vue&type=script&setup=true&lang=js"
export * from "./LoanPurpose.vue?vue&type=script&setup=true&lang=js"

import "./LoanPurpose.vue?vue&type=style&index=0&id=a0a5574c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0a5574c"]])

export default __exports__